import { render, staticRenderFns } from "./BaseModalChipsListItem.vue?vue&type=template&id=4eb9d8fb&scoped=true"
import script from "./BaseModalChipsListItem.vue?vue&type=script&lang=js"
export * from "./BaseModalChipsListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseModalChipsListItem.vue?vue&type=style&index=0&id=4eb9d8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb9d8fb",
  null
  
)

export default component.exports